export default "__VITE_ASSET__DOfuUUu5__"